import React, {useEffect}from 'react';
import './Modal.css';

const Modal = ({ show, handleClose, children }) => {
  useEffect(() => {
  if (show) {
    const scrollY = window.scrollY;

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.overflow = "hidden";
  } else {
    const scrollY = document.body.style.top;

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.overflow = "";

    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  }

  return () => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.overflow = "";
  };
}, [show]);
  return (
    <div
      className={`modal ${show ? 'show' : 'hide'}`}
      style={{ display: show ? 'flex' : 'none' }}
      onClick={handleClose}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <span className="close" onClick={handleClose}>
          ✕
        </span>
        {children}
      </div>
    </div>
  );
};

export default Modal;
